import React from 'react';
import { Box, Typography } from '@availity/element';
import { useNavigate } from 'react-router-dom';
import Button from '../../Utils/components/Button';
import usersIcon from '../../../static/assets/icons/users.svg';
import codeIcon from '../../../static/assets/icons/code.svg';
import suitcaseIcon from '../../../static/assets/icons/suitcase.svg';
import { iconFilters } from '../../../static/constants/theme';

interface APICatalogFeatureProps {
  title: string;
  description: string;
  documentation: string;
  route: string;
}

const iconMap: Record<string, string> = {
  'For Decision Makers': suitcaseIcon,
  'For Developers': codeIcon,
  'For Innovators': usersIcon,
};

const APICatalogFeature: React.FC<APICatalogFeatureProps> = ({ title, description, documentation, route }) => {
  const navigate = useNavigate();
  
  return (
  <Box className="api-catalog-feature">
    <Box className="api-catalog-feature__icon-wrapper">
    {iconMap[title] && (
        <Box 
          component="img"
          src={iconMap[title]}
          alt=""
          className="api-catalog-feature__icon"
          sx={{ filter: iconFilters.brightOrange }}
        />
      )}
    </Box>
    <Box className="api-catalog-feature__content">
      <Typography className="api-catalog-feature__title">
        {title}
      </Typography>
      <Typography className="api-catalog-feature__description">
        {description}
      </Typography>
    </Box>
    <Box sx={{ width: { xs: 1, lg: 'fit-content' } }}>
      <Button variant="navbar-signup"
        sx={{
          width: 'fit-content'
        }}
        onClick={() => navigate(route)}
      >
        {documentation}
      </Button>
    </Box>
  </Box>
  );
};

const APICatalogSection = () => (
  <Box
    sx={{
      width: 1,
      py: { xs: 8, md: 16.5 },
      background: '#000C30',
      borderTop: '1px solid #124383',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: { xs: 6, md: 11 },
    }}
  >
    <Box
      sx={{
        width: { xs: 1, lg: 1200 },
        maxWidth: 1200,
        px: { xs: 2, lg: 0 },
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 8,
      }}
    >
      <Box
        sx={{
          width: { xs: 1, lg: 976 },
          maxWidth: 976,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 2,
        }}
      >
        <Typography
          sx={{
            textAlign: 'center',
            color: '#91B0DA',
            fontSize: { xs: 18, md: 18 },
            fontFamily: 'Lato',
            fontWeight: 400,
            lineHeight: 1.444,
          }}
        >
          Documentation
        </Typography>
        <Typography
          sx={{
            textAlign: 'center',
            color: 'white',
            fontSize: { xs: 28, md: 36 },
            fontFamily: 'Montserrat',
            fontWeight: 600,
            lineHeight: 1.333,
          }}
        >
          From Idea to Integration
        </Typography>
      </Box>
      
      <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, gap: 5, width: 1, maxWidth: 1200, justifyContent: 'center' }}>
        <APICatalogFeature
          title="For Decision Makers"
          description="Discover APIs by business outcome. Explore use cases like eligibility checks or claims status, see real examples, and validate value fast."
          documentation="View API Overview"
          route="/docs/overview"
        />
        <APICatalogFeature
          title="For Developers"
          description="Find, test, and integrate APIs quickly. Browse examples, view sample calls, and get from discovery to implementation in minutes."
          documentation="View API Specifications"
          route="/docs/api-spec"
        />
        <APICatalogFeature
          title="For Innovators"
          description="Build smarter workflows with data-ready APIs. Power use cases like automation, predictions, or copilots using clear examples and quick starts."
          documentation="View MCP Overview"
          route="/docs/ai-management"
        />
      </Box>
    </Box>
  </Box>
);

export default APICatalogSection;